import store from '@/store';

export default {
    name: "permission",
    bind(el, binding) {
        const modules = store.getters.modules;
        const moduleId = binding.value;
        if(!modules.some(item => item.moduleId == moduleId)) {
            el.style.display = 'none';
        }
    }
};
